module.exports = __webpack_public_path__ + "images/emoji/japanese_ogre.81f44d4192362ff7b10f.png";